module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "name",
      "placeholder": _vm.$t('form_1')
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "email",
      "placeholder": _vm.$t('form_2')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "phone",
      "placeholder": _vm.$t('form_3')
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.content),
      expression: "content"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "id": "content",
      "placeholder": _vm.$t('form_4')
    },
    domProps: {
      "value": (_vm.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.content = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "right",
      "overflow": "hidden"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "color": "#f67c4f"
    }
  }, [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "border-radius": "25px",
      "padding": "5px 20px",
      "background": "#526193 !important",
      "border": "1px solid #526193"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('form_submit')))])]), _vm._v(" "), _c('div', {
    staticClass: "mask",
    attrs: {
      "id": "mask"
    }
  }, [_c('div', {
    staticStyle: {
      "border-radius": "5px",
      "margin-top": "150px",
      "background": "white",
      "width": "250px",
      "margin-left": "calc((100% - 250px)/2)",
      "text-align": "center",
      "padding": "30px 15px"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "line-height": "22px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('form_submitted')) + "\n                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "background": "#526193 !important",
      "border-radius": "25px",
      "border": "none",
      "padding": "5px 30px !important",
      "font-size": "14px !important"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.closeMask()
      }
    }
  }, [_vm._v("OK")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('i', {
    staticClass: "bi bi-check-circle-fill",
    staticStyle: {
      "color": "#43b143",
      "font-size": "40px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17bde2f8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/contact.vue
// module id = 415
// module chunks = 1